require('es6-promise').polyfill()

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import TabLayout from '@/components/TabLayout'
import CellGroup from '@/components/CellGroup'
// import Cell from '@/components/Cell'
import Column from '@/components/Column.vue'
import TimerTip from '@/components/TimerTip.vue'
import AgreeIterms from '@/components/AgreeIterms.vue'
import Candidate from '@/components/Candidate'
import Panel from '@/components/Panel.vue'
import VueImgInputer from 'vue-img-inputer'
// import CryptoJS from './utils/sha1'
// import generateNonceStr from './utils/nonceStr'
import Occupation from '@/components/Occupation.vue'
import Login from '@/components/Login'

// import AppConfig from './config/app'

import AlertPlugin from 'vux/src/plugins/alert/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import Datetime from 'vux/src/components/datetime/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ViewBox from 'vux/src/components/view-box/index.vue'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


Vue.use(AlertPlugin)
Vue.use(AjaxPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)

Vue.component('Cell', Cell)
Vue.component('Confirm', Confirm)
Vue.component('Datetime', Datetime)
Vue.component('Group', Group)
Vue.component('Icon', Icon)
Vue.component('Popup', Popup)
Vue.component('PopupPicker', PopupPicker)
Vue.component('Swiper', Swiper)
Vue.component('Tabbar', Tabbar)
Vue.component('ViewBox', ViewBox)
Vue.component('XAddress', XAddress)
Vue.component('XButton', XButton)
Vue.component('XDialog', XDialog)
Vue.component('XInput', XInput)
Vue.component('XSwitch', XSwitch)
Vue.component('XTextarea', XTextarea)

Vue.component(TabLayout.name, TabLayout)
Vue.component(CellGroup.name, CellGroup)
// Vue.component(Cell.name, Cell)
Vue.component(Column.name, Column)
Vue.component(Login.name, Login)
Vue.component(TimerTip.name, TimerTip)
Vue.component(AgreeIterms.name, AgreeIterms)
Vue.component(Candidate.name, Candidate)
Vue.component(Panel.name, Panel)
Vue.component(Occupation.name, Occupation)

Vue.component('VueImgInputer', VueImgInputer)

Vue.config.productionTip = false

// const appId = 'wxef64cfa3a28363ac'
// const appSecret = '25499639a1aaad3e945bedc4351035bc'
// const accessTokenUrl = '/wxapi/cgi-bin/token?grant_type=client_credential&appid=' + appId + '&secret=' + appSecret
// let accessToken = ''
// Vue.http.get(accessTokenUrl).then(response => {
//   accessToken = response.data.access_token
//   const jsapiTicketUrl = '/wxapi/cgi-bin/ticket/getticket?access_token=' + accessToken + '&type=jsapi'
//   Vue.http.get(jsapiTicketUrl).then(response => {
//     const jsapiTicket = response.data.ticket
//     if (process.env.NODE_ENV === 'development') console.log('jsapi_ticket', jsapiTicket)
//     let url = AppConfig.app.url // 最后的 / 一定要有
//     const timestamp = Math.floor(Date.now() / 1000)
//     if (process.env.NODE_ENV === 'development') console.log('timestamp:', timestamp)
//     const nonceStr = generateNonceStr(10)
//     if (process.env.NODE_ENV === 'development') console.log('noncestr:', nonceStr)
//     const string1 = 'jsapi_ticket=' + jsapiTicket + '&noncestr=' + nonceStr + '&timestamp=' + timestamp + '&url=' + url
//     if (process.env.NODE_ENV === 'development') console.log('string1:', string1)
//     const signature = CryptoJS.SHA1(string1).toString()
//     if (process.env.NODE_ENV === 'development') console.log('signature:', signature)
//     Vue.wechat.config({
//       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//       appId: appId, // 必填，公众号的唯一标识
//       timestamp: timestamp, // 必填，生成签名的时间戳
//       nonceStr: nonceStr, // 必填，生成签名的随机串
//       signature: signature, // 必填，签名，见附录1
//       jsApiList: [
//         'onMenuShareTimeline',
//         'onMenuShareAppMessage',
//         'onMenuShareQQ',
//         'onMenuShareQZone'
//       ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//     })
//   })
// })
// console.log(window.location.href.replace(/#.+$/, ''))
// let url = encodeURIComponent(window.location.href.replace(/#.+$/, '')) // 最后的 / 一定要有
// // console.log(url)
// Vue.http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(response => {
//   console.log('before1 config')
//   Vue.wechat.config({
//     debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//     appId: response.data.appId, // 必填，公众号的唯一标识
//     timestamp: response.data.timestamp, // 必填，生成签名的时间戳
//     nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
//     signature: response.data.signature, // 必填，签名，见附录1
//     jsApiList: [
//       'onMenuShareTimeline',
//       'onMenuShareAppMessage',
//       'onMenuShareQQ',
//       'onMenuShareQZone'
//     ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//   })
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js